import {
  SEARCH,
  SORT,
  LOADING,
  LOAD_TRENDING,
  MOVE_PAGE,
} from './constants';

export function loadTrending(items) {
  return {
    type: LOAD_TRENDING,
    isLoading: false,
    items,
  };
};

export function search(query, items){
  return {
    type: SEARCH,
    query,
    items,
  };
};

export function loading(isLoading){
  return {
    type: LOADING,
    isLoading,
  };
};

export function moveToPage(page){
  return {
    type: MOVE_PAGE,
    page,
  };
};

export function sortResults(items, order){
  return {
    type: SORT,
    items,
    order,
  };
};



// WEBPACK FOOTER //
// ./src/containers/search/actions.js